export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.19.0';
//# sourceMappingURL=version.js.map